import { render, staticRenderFns } from "./HolidaysProgramDetails.vue?vue&type=template&id=20e5bbc8&scoped=true&"
import script from "./HolidaysProgramDetails.vue?vue&type=script&lang=ts&"
export * from "./HolidaysProgramDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5bbc8",
  null
  
)

export default component.exports